export const getDefaultSuggestions = (i18n: { t: (key: string) => string }) => {
  return [
    {
      comment: i18n.t('comments.comment_suggestion.options.good_work'),
      option: 'GOOD_WORK'
    },
    {
      comment: i18n.t('comments.comment_suggestion.options.congratulations'),
      option: 'CONGRATULATIONS'
    },
    {
      comment: i18n.t('comments.comment_suggestion.options.thanks_for_sharing'),
      option: 'THANKS_FOR_SHARING'
    }
  ]
}
